/*
 * DRIVLY-UI React Components
 * @license MIT
 */
var e=!1;if("undefined"!=typeof window)try{var t=Object.defineProperty({},"passive",{get:function(){return e=!0,!0}});window.addEventListener("test",t,t),window.removeEventListener("test",t,t)}catch(t){e=!1}var n=!!e&&{passive:!1};export{n as nonPassive};
//# sourceMappingURL=aggresiveCapture.js.map
